import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";

const FEATURE_FLAG_URL = "/fulfilment/accounts-payable/api/v1/vip/feature-flags";

async function fetchPaymentFlag(): Promise<boolean> {
  const res = await api.post(FEATURE_FLAG_URL, { features: ["vip_payments"] });
  return res?.vip_payments === "allow";
}

/**
 * Returns true when the "vip_payments" feature flag is enabled for the current user.
 * Mirrors the useInvoiceV2Flag pattern — 5-min cache, no retry, fail-safe false.
 */
export function usePaymentFlag(): boolean {
  const { data: isEnabled = false } = useQuery(
    ["invoiceFeatureFlag", "vip_payments"],
    fetchPaymentFlag,
    {
      staleTime: 5 * 60 * 1000,
      retry: false,
    },
  );
  return isEnabled;
}
